module.exports = __webpack_public_path__ + "static/img/mobii.ce7fca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobiigw/mobii.png
// module id = g+wf
// module chunks = 1